import { GeoJSONSource, Map as MapLibreMap } from "maplibre-gl"

// Animation timing for pulsing effect
const PULSE_DURATION = 2000 // Change this: smaller = faster pulse
const PULSE_SCALE = 1 // Change this: how much the ring expands (0.5 = 50% larger)
const PULSE_OPACITY = 0.8 // Change this: maximum opacity of the pulse ring
const DOT_RADIUS = 48 // Size of the dot

const CANVAS_SIZE = DOT_RADIUS + DOT_RADIUS * PULSE_SCALE // Account for pulse expansion

export type DrivingIconLayer = {
  width: number
  height: number
  data: Uint8ClampedArray
  context: CanvasRenderingContext2D
  onAdd: () => void
  render: () => boolean
}

// Class used to create a location dot on the map

const DriverIcon = (map: MapLibreMap): DrivingIconLayer => {
  const size = CANVAS_SIZE

  return {
    width: size,
    height: size,
    data: new Uint8ClampedArray(size * size * 4),
    context: null as unknown as CanvasRenderingContext2D,

    onAdd() {
      const canvas = document.createElement("canvas")
      canvas.width = this.width
      canvas.height = this.height
      this.context = canvas.getContext("2d") as CanvasRenderingContext2D
    },

    render() {
      const directionsSource = map.getSource(
        "maplibre-gl-directions",
      ) as GeoJSONSource
      // @ts-ignore
      const driverInitials = directionsSource?._data?.features?.find(
        (feature: any) =>
          feature.properties?.type === "WAYPOINT" &&
          feature.properties?.action === "from_driver_location",
      )?.properties?.driverInitials

      const context = this.context
      const centerX = size / 2
      const centerY = size / 2
      const radius = DOT_RADIUS / 2

      const t = (performance.now() % PULSE_DURATION) / PULSE_DURATION
      const pulseIntensity = (Math.sin(t * Math.PI * 2) + 1) / 2 // 0 to 1

      // Clear canvas
      context.clearRect(0, 0, this.width, this.height)

      // Draw pulsing ring
      const outerRadius = radius + pulseIntensity * radius * PULSE_SCALE
      const outerOpacity = PULSE_OPACITY * (1 - pulseIntensity)

      context.beginPath()
      context.arc(centerX, centerY, outerRadius, 0, Math.PI * 2)
      context.fillStyle = `rgba(182, 214, 255, ${outerOpacity})` // Same color as dot but transparent
      context.fill()

      // Draw main circle
      const dotColor = "#B6D6FF"

      context.beginPath()
      context.arc(centerX, centerY, radius, 0, Math.PI * 2)
      context.fillStyle = dotColor
      context.fill()

      // Draw driver initials if available
      if (driverInitials) {
        context.fillStyle = "black"
        context.font = "20px Arial"
        context.textAlign = "center"
        context.textBaseline = "middle"
        context.fillText(driverInitials, centerX, centerY)
      }

      // Update image data
      this.data = context.getImageData(0, 0, this.width, this.height).data

      // Trigger map repaint
      map.triggerRepaint()

      return true
    },
  }
}

export default DriverIcon
